export default {
  methods: {
    routeFoodItem({ type, id, noBack = false }) {
      const rte = { name: type, params: { id } };
      if (noBack) {
        this.$router.replace(rte);
      } else {
        this.$router.push(rte);
      }
    },
    routeEditFoodItem({ type, id }) {
      const name = `edit-${type}`;
      this.$router.push({ name, params: { id } });
    },
    routeBrowse({ categories, component, noBack = false }) {
      // TODO don't need component to get to store
      if (categories && component) {
        const cats = (typeof categories === 'string' ? [categories] : categories);
        component.$store.commit('browse/categories', cats);
      }

      if (noBack) {
        this.$router.replace({ name: 'browse' });
      } else {
        this.$router.push({ name: 'browse' });
      }
    },
    routeShoppingList({ id, noBack = false }) {
      const rte = { name: 'shoppingList', params: { id } };
      if (noBack) {
        this.$router.replace(rte);
      } else {
        this.$router.push(rte);
      }
    },
    goBack() {
      if (this.$store.state.routed) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'browse' });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/routing.js